// Note: The first file of a module here, must also register the module

import "./admin-campaigns.component";
import "./admin-logins.component";
import "./admin-live.component";
import "./admin-organisations.component";
import "./admin-tabs.component";
import "./admin-users.component";
import "./limit-used.component";

import "./dialogs";
import "./lists";
import "./filter";
